export default __webpack_public_path__ + "static/media/socicon.578ecee5.ttf";